import { render, staticRenderFns } from "./SetAdjustmentDlg.vue?vue&type=template&id=2a15e6c6&"
import script from "./SetAdjustmentDlg.vue?vue&type=script&lang=js&"
export * from "./SetAdjustmentDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports